import { render, staticRenderFns } from "./order_confirm.vue?vue&type=template&id=61f7800a&scoped=true"
import script from "./order_confirm.vue?vue&type=script&lang=js"
export * from "./order_confirm.vue?vue&type=script&lang=js"
import style0 from "./order_confirm.vue?vue&type=style&index=0&id=61f7800a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f7800a",
  null
  
)

export default component.exports